<button mat-icon-button matTooltip="Edit" (click)="edit()" disableRipple matTooltipPosition="right">
  <mat-icon>edit</mat-icon>
</button>

<button mat-icon-button matTooltip="Export" (click)="downloadFilter()" disableRipple matTooltipPosition="right">
  <mat-icon>file_download</mat-icon>
</button>

<div class="delete-button-wrapper" [class.expanded]="showDeleteConfirm">
  <button matTooltip="Delete" mat-icon-button color="warn" (click)="deleteToggle()" *ngIf="!showDeleteConfirm" disableRipple matTooltipPosition="right">
    <mat-icon>delete</mat-icon>
  </button>
  <button mat-button color="warn" (click)="delete()" *ngIf="showDeleteConfirm" disableRipple>
    Are you sure?
  </button>
</div>
